// Central export for all services
import apiService from './api';
import authService from './authService';
import userService from './userService';
import bagService from './bagService';
import itemService from './itemService';
import affiliateService from './affiliateService';
import notificationService from './notificationService';
import shoppableService from './shoppableService';
import propertyService from './propertyService';

// Export individual services
export {
  apiService,
  authService,
  userService,
  bagService,
  itemService,
  affiliateService,
  notificationService,
  shoppableService,
  propertyService,
};

// Export as default object for convenience
export default {
  api: apiService,
  auth: authService,
  user: userService,
  bag: bagService,
  item: itemService,
  affiliate: affiliateService,
  notifications: notificationService,
  properties: propertyService,
};
